/**
 * Created by liuzhq on 2018/8/16.
 */

var _Vue;
var _preferLang = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage)

var Inter = function(options) {
  const langWords = options.langWords || "";
  if (!langWords) {
    return;
  }

  // 设置当前用户语言
  _Vue.prototype.$interLang = options.lang || _preferLang;

  // 动态设置语言方法
  _Vue.prototype.$setLang = function (lang) {
    _Vue.prototype.$interLang = lang;
    _preferLang = lang;
  }

  // 国际化翻译
  _Vue.prototype.$TT = function (words, lang, replace) {
    lang = lang || _preferLang;
    var wordsReplaced = words;
    if ( langWords[words] && langWords[words][lang]) {
      wordsReplaced = langWords[words][lang];
    } else {
      return wordsReplaced;
    }
    if (!replace) {
      return wordsReplaced;
    }
    for(var i=0; i<replace.length;i++) {
      wordsReplaced = wordsReplaced.replace(/\$\{TT}/, replace[i]);
    }
    return wordsReplaced;
  }
}
function install(Vue){
  // 已经初始化
  if (install.installed && _Vue === Vue) {
    return
  }
  install.installed = true;
  _Vue = Vue;
}

Inter.install = install;

module.exports = Inter;


// WEBPACK FOOTER //
// ./src/plugins/vue-internationalization.js